import React, { useEffect, useState } from 'react';
import { Logo } from './Logo';
import { RESERVA_LINK } from '../data/retiro';
const NAV = [{
  label: 'El Viaje',
  href: '#isla'
}, {
  label: 'Los Elementos',
  href: '#elementos'
}, {
  label: 'Facilitadoras',
  href: '#facilitadoras'
}, {
  label: 'Inversión',
  href: '#inversion'
}];
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${scrolled ? 'py-3 shadow-sm backdrop-blur-md' : 'py-5'}`} style={{
    backgroundColor: scrolled ? 'rgba(251,247,239,0.9)' : 'transparent'
  }} data-id="element-26">
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between px-5 sm:px-8" data-id="element-27">
        <a href="#top" aria-label="Espacio para el Alma — inicio" className="shrink-0" data-id="element-28">
          <Logo width={132} height={44} className={scrolled ? '' : 'brightness-0 invert'} data-id="element-29" />
        </a>
        <nav className="hidden md:flex items-center gap-8" aria-label="Navegación principal" data-id="element-30">
          {NAV.map(item => <a key={item.href} href={item.href} className={`text-sm tracking-wide transition-colors hover:opacity-70 ${scrolled ? 'text-[var(--ink)]' : 'text-white'}`} data-id="element-31">
              {item.label}
            </a>)}
        </nav>
        <a href={RESERVA_LINK} className="rounded-full px-5 py-2.5 text-sm font-medium text-white transition-transform hover:scale-[1.03]" style={{
        backgroundColor: 'var(--darkgoldenrod)'
      }} data-id="element-32">
          Reservar
        </a>
      </div>
    </header>;
}